import React, { useEffect, useState } from 'react';
import { fetchLogList } from '../../services/logApi';

// 페이징1
import Pagination from '../base/Pagination';

export default function Log() {
    const [logList, setLogList] = useState([]);

    //페이징2
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 10;

    // api불러오기
    useEffect(() => {
    const getLogs = async () => {
      try {
        const logs = await fetchLogList();
        setLogList(logs);
      } catch (error) {
        console.error("로그 요청 실패:", error);
        alert("로그 목록을 가져오는 데 실패했습니다.");
      }
    };

    getLogs();
  }, []);

  // 페이징3
  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logList.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(logList.length / logsPerPage);

    return (
        <div className="logpage">
            <h1>로그 관리</h1>
            <div className="log_box">
                <div className="table">
                    <table>
                        <colgroup>
                            <col width="10%" />
                            <col width="10%" />
                            <col width="10%" />
                            <col width="10%" />
                            <col width="10%" />
                            <col width="10%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">이름</th>
                                <th scope="col">아이디</th>
                                <th scope="col">작업내용</th>
                                <th scope="col">작업대상</th>
                                <th scope="col">IP주소</th>
                                <th scope="col">일시</th>
                            </tr>
                        </thead>
                        <tbody>
                        {currentLogs.length > 0 ? (
                            currentLogs.map((log, index) => (
                            <tr key={index}>
                                <td>{log.admin_name}</td>
                                <td>{log.admin_username}</td>
                                <td>{log.content}</td>
                                <td>{log.username || "-"}</td>
                                <td>{log.ip}</td>
                                <td>{log.create_date}</td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>로그가 없습니다.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </div>
        </div>
    );
}
